exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-item-container {\n  height: 100%;\n  padding-bottom: 30px; }\n\n.service-item {\n  height: 100%;\n  box-shadow: 5px 5px 20px 5px grey;\n  margin-bottom: 30px;\n  transition: 0.8s box-shadow; }\n  .service-item:hover {\n    box-shadow: 0px 0px 50px 10px #49c466; }\n\n.service-item-header {\n  height: 110px;\n  color: white;\n  text-align: center;\n  font-size: 35px;\n  line-height: 45px;\n  text-transform: uppercase;\n  padding: 0px 15px;\n  background-color: #49c466;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  text-shadow: 2px 2px 0 #297e3d, 4px 4px 0 #35a550; }\n\n.service-item-body {\n  padding: 15px;\n  min-height: 220px; }\n\n.service-item-body p {\n  text-align: justify; }\n\n.service-heading {\n  margin: 15px 0;\n  text-transform: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/services/service-card/service-card.component.scss
// module id = ../../../../../src/app/services/service-card/service-card.component.scss
// module chunks = main